import { render } from "./MediaLibraryPicker.vue?vue&type=template&id=ba300a08&scoped=true"
import script from "./MediaLibraryPicker.vue?vue&type=script&lang=js"
export * from "./MediaLibraryPicker.vue?vue&type=script&lang=js"

import "./MediaLibraryPicker.vue?vue&type=style&index=0&id=ba300a08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba300a08"

export default script